var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.hasFlash)?_c('div',{staticClass:"italic rounded",class:_vm.messageClass,on:{"click":function($event){_vm.isDismissed = true}}},[_c('p',[_vm._v(_vm._s(_vm.message))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }